/**
 * company-api.js
 *  会社情報関連のAPI
 */
import session from '../session'

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

var uri = process.env.API_ENDPOINT

export default {
  /**
   * 会社情報関連GETリクエスト
   * @returns レスポンス
   */
  getCompanyInfo (queryParameter) {
    return session.get('{0}/api/hrm_apps/company/get_company_info?{1}'.format(uri, queryParameter))
  },
}



// WEBPACK FOOTER //
// ./src/api/company/company-api.js